module.exports = __webpack_public_path__ + "static/media/projectcard.31fa3e34.PNG";